import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import configurePdfjs from "./utils/pdfjs-config";

// Configure PDF.js before rendering the app
configurePdfjs();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
